export default __webpack_public_path__ + "static/media/MODALfrijol_ZH.cc8e790c.jpg";